import { createFileRoute, redirect } from "@tanstack/react-router";
import { z } from "zod";

import { LoginForm } from "@/components/auth/login-form";
import { meQueryOptions } from "@/lib/auth";

const searchSchema = z.object({
  redirect: z.string().optional(),
});

export const Route = createFileRoute("/login")({
  validateSearch: searchSchema,
  beforeLoad: async ({ context, search }) => {
    const user = await context.queryClient.ensureQueryData(meQueryOptions);
    if (user) throw redirect({ href: safeRedirect(search.redirect) });
  },
  component: LoginPage,
});

/** Only allow same-app relative paths as post-login destinations. */
export function safeRedirect(target: string | undefined): string {
  if (!target || !target.startsWith("/") || target.startsWith("//")) return "/";
  return target;
}

function LoginPage() {
  const { redirect: target } = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <main className="bg-muted/40 flex min-h-screen items-center justify-center p-6">
      <div className="w-full max-w-sm space-y-6">
        <div className="space-y-1 text-center">
          <h1 className="text-2xl font-semibold tracking-tight">Sign in</h1>
          <p className="text-muted-foreground text-sm">Use your work email and password.</p>
        </div>
        <LoginForm onSuccess={() => navigate({ href: safeRedirect(target), replace: true })} />
      </div>
    </main>
  );
}
